import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./Login";
import Dashboard from "./pages/Dashboard";
import Report from "./pages/Report";
import Users from "./pages/Users";
import Document from "./pages/Document";
import Layout from "./Layout";
import Graph from "./pages/Graph";

const App = () => {
  const isLoggedIn = !!localStorage.getItem("token");

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />

        {isLoggedIn && (
          <Route path="" element={<Layout />}>
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="report" element={<Report />} />
            <Route path="users" element={<Users />} />
            <Route path="Document" element={<Document />} />
            <Route path="Graph" element={<Graph />} />
          </Route>
        )}

        <Route path="*" element={<Navigate to={isLoggedIn ? "/dashboard" : "/login"} />} />
      </Routes>
    </Router>
  );
};

export default App;
